import { FC } from 'react';
import classNames from 'classnames';
import { darkStyles, lightStyles, scoreStyles } from './styles.css';
import { formatEval } from '../../utils';
import { Eval } from '../../types';

type Props = {
  value: Eval;
};

const Score: FC<Props> = ({ value }) => {
  const formatted = formatEval(value);
  const sign = formatted[0];

  return <span className={classNames(scoreStyles, sign === '-' ? darkStyles : lightStyles)}>{formatted}</span>;
};

export default Score;
